/* eslint-disable jsx-a11y/alt-text */
import { FC, memo } from "react";
import { useDrag, useDrop } from "react-dnd";

/**
 * 資料アップロード
 * VIDEO DnD 並び替えコンポーネント
 */

export const ItemTypes = {
  CARD: "card",
};

export interface CardProps {
  id: string;
  url: string;
  className: string;
  fileName: string;
  onClick: any;
  moveCard: (id: string, to: number) => void;
  findCard: (id: string) => { index: number };
}

interface Item {
  id: string;
  originalIndex: number;
}

export const CardVdo: FC<CardProps> = memo(function Card({
  id,
  url,
  className,
  fileName,
  onClick,
  moveCard,
  findCard,
}) {
  const originalIndex = findCard(id).index;
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemTypes.CARD,
      item: { id, originalIndex },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      end: (item, monitor) => {
        const { id: droppedId, originalIndex } = item;
        const didDrop = monitor.didDrop();
        if (!didDrop) {
          moveCard(droppedId, originalIndex);
        }
      },
    }),
    [id, originalIndex, moveCard]
  );
  const [, drop] = useDrop(
    () => ({
      accept: ItemTypes.CARD,
      canDrop: () => false,
      hover({ id: draggedId }: Item) {
        if (draggedId !== id) {
          const { index: overIndex } = findCard(id);
          moveCard(draggedId, overIndex);
        }
      },
    }),
    [findCard, moveCard]
  );
  const onClickHandle = (setid: string) => {
    if (onClick) onClick(setid);
  };

  const opacity = isDragging ? 0 : 1;
  return (
    <div
      ref={(node) => drag(drop(node))}
      style={{ opacity, padding: "0.5rem 1rem",backgroundRepeat: "no-repeat",backgroundPosition: "center", backgroundImage:"url(/img/video_show.png)",height:"115px",verticalAlign: "bottom",display:"table-cell"}}
      className={className}
    >
      {/* <video onClick={() => onClickHandle(id)}>
        <source src={url + "#t=1"} />
      </video> */}
      <div style={{backgroundColor: "wheat",width: "165px", overflowWrap:"break-word"}}>{fileName.split("/").slice(-1)[0]}</div>
    </div>
  );
});
